<template>
  <div>
    <v-dialog
      v-model="dialog"
      persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      class="ppmpModal"
    >
      <v-card>
        <v-toolbar dark color="green darken-2">
          <v-toolbar-title>Consolidate Purchase Requests</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="clickCloseMainDialogPR()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-row class="mt-1">
          <v-col lg="6" class="pl-5">
            <v-data-table
              v-model="formData.Lists"
              :headers="headers"
              :search="searchText"
              :items="prList"
              class="elevation-2"
              item-key="PRID"
              show-select
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-text-field
                    style="max-width: 300px"
                    v-model="searchText"
                    append-icon="mdi-magnify"
                    placeholder="Search.."
                    color="green darken-2"
                    class="mb-2 mr-2"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-toolbar>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <span class="text-no-wrap">
                <v-icon small class="mr-2" @click="viewPR(item)">
                  visibility
                </v-icon>
                <v-icon
                  small
                  class="mr-2"
                  color="red accent-4"
                  @click="print(item)"
                >
                  mdi-printer
                </v-icon>
                </span>
              </template>
              <template v-slot:no-data> No Records Yet </template>
            </v-data-table>
          </v-col>
          <v-divider vertical></v-divider>
          <v-col lg="6" class="pr-5">
            <v-data-table
              :headers="headers1"
              :search="searchText1"
              :items="formData.Lists"
              class="elevation-2"
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-text-field
                    style="max-width: 300px"
                    v-model="searchText1"
                    append-icon="mdi-magnify"
                    placeholder="Search.."
                    color="green darken-2"
                    class="mb-2 mr-2"
                    single-line
                    hide-details
                  ></v-text-field>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="red darken-2"
                    dark
                    outlined
                    elevation="2"
                    class="mb-2 mr-2"
                    @click="reset()"
                  >
                  <v-icon>mdi-refresh</v-icon>
                    Reset
                  </v-btn>
                  <v-btn
                    color="green darken-2"
                    outlined
                    :disabled="formData.Lists.length < 1"
                    elevation="2"
                    class="mb-2"
                    @click="consolidate()"
                  >
                    <v-icon>mdi-file-sync-outline</v-icon>
                    Consolidate
                  </v-btn>
                </v-toolbar>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-icon
                  small
                  class="mr-2"
                  color="red accent-4"
                  @click="removefromlist(item)"
                >
                  mdi-delete
                </v-icon>
              </template>
              <template v-slot:no-data> No Records Yet </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogConfirm" max-width="500px">
      <v-card>
        <v-card-title class="headline pt-5">Confirmation</v-card-title>
        <div class="mx-6">
          Are you sure you want to consolidate these Purchase Requests?
        </div>
        <v-card-actions class="mt-5">
          <v-spacer></v-spacer>
          <v-btn color="grey darken-2" outlined @click="dialogConfirm = false">Cancel</v-btn>
          <v-btn color="green darken-2 white--text" @click="confirmConsolidate()" :loading="loading"><v-icon class="mr-1">mdi-check-circle</v-icon> Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <prModlal :prData="prItem" />
    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
export default {
  props: {
    prData: {},
    dialogMenu: null,
  },
  components: {
    prModlal: () => import("./PRViewItem"),
  },
  data: () => ({
    dialog: false,
    searchText: "",
    searchText1: "",
    searchTimeout: null,
    amountErr: null,
    editItemId: null,
    loading: true,
    fadeAwayMessage: {
      show: false,
      type: "success",
      header: "Successfully Saved!",
      message: "",
      top: 10,
    },
    isLoading: false,
    menu: false,
    menu1: false,
    formData: {
      Lists: []
    },
    addPPMPDialog: false,
    prList: [],
    budgetList: [],
    prItem: [],

    headers: [
      // {
      //   text: "",
      //   sortable: true,
      //   value: "checkbox",
      //   class: "green darken-2 white--text text-caption font-weight-bold",
      // },
      {
        text: "PR No.",
        sortable: true,
        value: "PRCODETemp",
        class: "green darken-2 white--text text-caption font-weight-bold",
      },
      {
        text: "PR Purpose",
        value: "PrPurpose",
        sortable: true,
        class: "green darken-2 white--text text-caption font-weight-bold",
      },
      {
        text: "Fund",
        value: "FundCode",
        sortable: true,
        class: "green darken-2 white--text text-caption font-weight-bold",
      },
      {
        text: "PR Date",
        value: "DateCreated",
        sortable: true,
        class: "green darken-2 white--text text-caption font-weight-bold",
      },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        class: "green darken-2 white--text text-caption font-weight-bold",
      },
    ],

       headers1: [
      {
        text: "PR No.",
        sortable: true,
        value: "PRCODETemp",
        class: "green darken-2 white--text text-caption font-weight-bold",
      },
      {
        text: "PR Purpose",
        value: "PrPurpose",
        sortable: true,
        class: "green darken-2 white--text text-caption font-weight-bold",
      },
      {
        text: "Fund",
        value: "FundCode",
        sortable: true,
        class: "green darken-2 white--text text-caption font-weight-bold",
      },
      {
        text: "PR Date",
        value: "DateCreated",
        sortable: true,
        class: "green darken-2 white--text text-caption font-weight-bold",
      },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        class: "green darken-2 white--text text-caption font-weight-bold",
      },
    ],
    dialogConfirm: false,
  }),
  watch: {
    prData: {
      handler(data) {
        if (data.PPMPID) {
          this.dialogAddItem = true;
          this.getItems();
        }
      },
      deep: true,
    },
    dialogMenu: {
      handler(data) {
        if (data) {
          this.dialog = true;
          this.initialize();
        }
      },
      deep: true,
    },
  },
  created() {},
  mounted() {
    this.eventHub.$on("closePRItemodal", () => {
      this.prItem = {};
      this.initialize();
    });
  },
  beforeDestroy() {
    this.eventHub.$off("closePRItemodal");
  },
  methods: {
    clickCloseMainDialogPR() {
      this.formData.Lists = [];
      this.dialog = false;
      this.dialogConfirm = false;
      this.prList = [];
      this.eventHub.$emit("closeModalCons", false);
    },
    print(data) {
      window.open(this.apiUrl + "/pr/report/" + data.PRID);
    },
    viewPR(item) {
      this.prItem = item;
      console.log(this.prItem);
    },
    initialize() {
      this.loading = true;
      let data = new FormData();
      data.append("searchText", '');
      this.axiosCall("/get/pr/to/consolidate", "POST", data).then((res) => {
        this.loading = false;
        this.prList = res.data.data.result;
      });
    },
    consolidate(){
      if((this.formData.Lists).length > 0){
      this.dialogConfirm = true;
      }
    },
    confirmConsolidate() {
      this.loading = true;
      let data = new FormData();
      data.append("List", JSON.stringify(this.formData.Lists));
      this.axiosCall("/consolidate/dbm/pr", "POST", data).then((res) => {
        console.log(res);
        this.loading = false;
        this.clickCloseMainDialogPR();
      });
    },
    reset () {
      this.formData.Lists = [];
    },
    removefromlist (data) {

      for(let [index, item] of  Object.entries(this.formData.Lists)){
					if(data.PRID == item.PRID){
            this.formData.Lists.splice(index, 1); 
					}
				}
    }
  },
};
</script>
<style scoped>
::v-deep .v-data-table-header th:first-child {
  background-color: #388e3c !important; /* green darken-2 */
}

::v-deep .v-data-table-header th:first-child .v-icon {
  color: white !important;
}
</style>